import axios from "axios";
import { successHandler, errorHandler } from "./resultHandler";
import querystring from "query-string";

export function postContactForm(name, company, email, country, message) {
  let body = {
    name,
    email,
    company,
    country,
    message
  };

  return axios
    .post("/php/contact.php", querystring.stringify(body), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    .then(successHandler())
    .catch(errorHandler({}));
}

export function getPdfByUrl(url) {
  return fetch("/php/downloadPdf.php?pdfUrl=" + encodeURIComponent(url)).then(
    response => {
      if (response.status >= 400) {
        let statusText = response.statusText.split("http")[0];

        throw new Error(
          "Error: HTTP-GET " +
            response.status +
            " " +
            response.statusText +
            " " +
            url
        );
      }

      return response;
    }
  );
}

export function getUrlHeaders(url) {
  return axios
    .get(
      "/php/getPdfMetadata.php",
      { params: { pdfUrl: url } },
      {
        responseType: "Array",
        headers: {}
      }
    )

    .then(response => {
      return response;
    })
    .catch(error => console.log(error));
}

export function getVideoVersions(videoID) {
  //Call Php skript and vimeo api
  return axios
    .get(
      "/php/getVimeoMetadata.php",
      { params: { videoId: videoID } },
      {
        responseType: "Array",
        headers: {}
      }
    )

    .then(response => {
      return {
        modifyingDate: response.data.timestamp,
        downloadUrl: response.data.downloadUrl
      };
    })
    .catch(error => console.log(error));
}

export async function isOnline() {
  try {
    const response = await fetch("/php/alive.php");
    return response.status === 200;
  } catch (e) {
    return false;
  }
}
